import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router';

import { HealtheraButton } from '../../../healtheraComponents';
import { Container, Body, Header } from '../../Shared/Table';

import ServiceConditionsContainer from './ServiceConditionsContainer';

export default function ServiceConditions() {
  const history = useHistory();

  function addNewCategory() {
    history.push('conditions/create');
  }

  return (
    <Container>
      <Header>
        <Typography variant="h4">Conditions</Typography>
        <HealtheraButton onClick={addNewCategory}>Add new</HealtheraButton>
      </Header>
      <Body>
        <ServiceConditionsContainer />
      </Body>
    </Container>
  );
}
